<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-1 font-weight-bold subtitle-1">
            {{ $t($route.meta.title) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- No -->
        <tr>
          <td class="width-3">
            <strong>問題No.</strong>
          </td>
          <td colspan="2">
            <span>{{ $route.query.no }}</span>
          </td>
        </tr>
        <!-- Proble Type -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("PROBLEM_TYPE") }}</strong>
          </td>
          <td colspan="2">
            <span>{{
              probleType.find((e) => e.key == item.type_value)
                ? probleType.find((e) => e.key == item.type_value).text
                : ""
            }}</span>
          </td>
        </tr>
        <!-- Directive -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("DIRECTIVE") }}</strong>
          </td>
          <td colspan="2">
            <span class="pre-wrap">{{ formGeneral.leadSentence }}</span>
          </td>
        </tr>
        <!-- Question -->
        <tr>
          <td class="width-3">
            <strong>{{ $t("QUESTION") }}</strong>
          </td>
          <td colspan="2" class="py-2">
            <v-row
              class="mx-0"
              v-for="(rowName, idx) in item.name"
              :key="`preview-${idx}`"
              :justify="
                item.name.length == 1 && (!rowName[0] || !rowName[2])
                  ? 'center'
                  : null
              "
            >
              <span class="pre-wrap text--h4">
                <v-row class="d-flex mt-1" no-gutters>
                  <span v-if="rowName[0]">{{ replaceText(rowName[0]) }}</span>
                  <template v-if="rowName[1] || rowName[1] == ''">
                    <v-btn
                      class="mx-2"
                      style="width: 25px; height: 25px"
                      fab
                      dark
                      x-small
                      color="#e47690"
                    >
                      <strong style="font-size: 16px">1</strong>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      style="width: 25px; height: 25px"
                      fab
                      dark
                      x-small
                      color="#96b74b"
                    >
                      <strong style="font-size: 16px">2</strong>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      style="width: 25px; height: 25px"
                      fab
                      dark
                      x-small
                      color="#5fa89f"
                    >
                      <strong style="font-size: 16px">3</strong>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      style="width: 25px; height: 25px"
                      fab
                      dark
                      x-small
                      color="#b37bde"
                    >
                      <strong style="font-size: 16px">4</strong>
                    </v-btn>
                  </template>
                  <template v-if="rowName[1] || rowName[1] == ''">
                    <span v-if="rowName[1]">{{ replaceText(rowName[1]) }}</span>
                  </template>
                </v-row>
              </span>
            </v-row>
          </td>
        </tr>
        <!-- Answer -->
        <tr>
          <td class="width-3" rowspan="2">
            <strong>{{ $t("ANSWER") }}</strong>
          </td>
          <td>
            <v-row class="ma-0">
              <span>{{ formGeneral.answers[0].value }}</span>
              <v-spacer />
              <v-btn
                class="mx-2"
                style="width: 25px; height: 25px"
                fab
                dark
                x-small
                color="#e47690"
              >
                <strong style="font-size: 16px">1</strong>
              </v-btn>
            </v-row>
          </td>
          <td>
            <v-row class="ma-0">
              <span>{{ formGeneral.answers[1].value }}</span>
              <v-spacer />
              <v-btn
                class="mx-2"
                style="width: 25px; height: 25px"
                fab
                dark
                x-small
                color="#96b74b"
              >
                <strong style="font-size: 16px">2</strong>
              </v-btn>
            </v-row>
          </td>
        </tr>
        <tr>
          <td>
            <v-row class="ma-0">
              <span>{{ formGeneral.answers[2].value }}</span>
              <v-spacer />
              <v-btn
                class="mx-2"
                style="width: 25px; height: 25px"
                fab
                dark
                x-small
                color="#5fa89f"
              >
                <strong style="font-size: 16px">3</strong>
              </v-btn>
            </v-row>
          </td>
          <td>
            <v-row class="ma-0">
              <span>{{ formGeneral.answers[3].value }}</span>
              <v-spacer />
              <v-btn
                class="mx-2"
                style="width: 25px; height: 25px"
                fab
                dark
                x-small
                color="#b37bde"
              >
                <strong style="font-size: 16px">4</strong>
              </v-btn>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  store: ["formGeneral"],
  props: ["probleType", "item", "isValue"],
  methods: {
    checkAnswerCorrect(value) {
      return Boolean(this.item.answer_correct[0] == value);
    },
    replaceText(name) {
      return name
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
  },
};
</script>
<style  scoped>
tr td {
  border: 1px solid #ccc;
  border-top: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>